"use client";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Ticket } from "lucide-react";
import { useEffect, useState } from "react";
import { useLocalStorage } from "usehooks-ts";
import { CartSwitcherOrder } from "./cart-switcher-order";
import { useTranslations } from "next-intl";

export function CartSwitcher() {
  const t = useTranslations("SiteHeader");
  const [cartItems, setCartItems] = useState<any>([]);
  const [locallySavedOrders, setLocallySavedOrders] = useLocalStorage<string[]>(
    "locally-saved-orders",
    [],
  );
  useEffect(() => {
    setCartItems(locallySavedOrders);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, locallySavedOrders);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="flex flex-row items-center px-2 opacity-50 cursor-pointer hover:pl-4  group hover:bg-transparent hover:opacity-80 transition-opacity duration-200">
          <div className="w-0 text-sm font-normal opacity-0 group-hover:w-16 group-hover:opacity-100 transition-all text-nowrap">
            {t('tickets')}
          </div>

          <div className="relative">
            <Ticket className="w-4 h-4" strokeWidth="1.5" />

            {cartItems.length > 0 && (
              <span className="absolute flex h-1.5 w-1.5 ml-3 -mt-4">
                <span className="absolute inline-flex w-full h-full bg-red-400 rounded-full opacity-75 animate-ping"></span>
                <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-red-500"></span>
              </span>
            )}
          </div>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {cartItems.length > 0 ? (
          <>
            <DropdownMenuLabel>{t('my-previous-orders')}</DropdownMenuLabel>
            <DropdownMenuSeparator />
            {cartItems.map((cartItem: any, idx: number) => (
              <CartSwitcherOrder orderReference={cartItem} key={idx} />
            ))}
          </>
        ) : (
          <DropdownMenuLabel>{t('no-orders-found')}</DropdownMenuLabel>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
